import {
  Button,
  Anchor,
  Center,
  Stack,
  Text,
  Loader,
  Box,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '@/routes';
import { getMutationResult } from '@/helpers/query';
import { useApproveTermsOfUseMutation } from '@/services/api';
import { useEffect, useState } from 'react';
import { notifications } from '@mantine/notifications';
import { IconShieldCheck } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from '@/data/features/user/user';
// eslint-disable-next-line import/no-unresolved
import Icon from '@/assets/images/lock.svg?react';
import classes from './style.module.css';

const TermsOfUse = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { isSentApprovation } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let { clientId } = useParams();

  if (!clientId) {
    const url = window.location.pathname;
    const segments = url.split('/').filter(Boolean);
    clientId = segments[segments.length - 1];
  }

  const [approveTerms] = useApproveTermsOfUseMutation();

  useEffect(() => {
    if (isSentApprovation) {
      navigate(routes.successAgreeTerms.path);
    }
  }, []);

  const handleContinue = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { isError } = await getMutationResult(
        { id: clientId },
        approveTerms,
      );

      if (isError) {
        notifications.show({
          title: t('globals.error.title'),
          message: t('globals.error.message'),
          color: 'red',
        });
      } else {
        dispatch(updateUser({ isSentApprovation: true }));
        navigate(routes.successAgreeTerms.path);
      }
    } catch (error) {
      notifications.show({
        title: t('globals.error.title'),
        message: t('globals.error.message'),
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      actions={null}
      title={null}
      subTitle={null}
      sideSize="sm"
    >
      <Center>
        <div className={classes.card}>
          <Box size={5}><Icon className={classes.icon} /></Box>

          <Text component="h1" className={classes.title}>
            הפרטיות שלך חשובה לנו
          </Text>

          <Text className={classes.paragraph}>
            אני מודע לכך שהסכמתי חיונית לצורך המשך תהליך
            הטיפול בפנייתי לייעוץ והכוונה פיננסית באמצעות מערכת קרדיט פרו,
            לרבות העברת מידע לגורמים מקצועיים מטעמה.
          </Text>

          <Stack gap={6} align="center" className={classes.shieldRow}>
            <IconShieldCheck size={20} stroke={2} />
            <Text className={classes.legal}>
              על ידי לחיצה להלן, אני מאשר/ת שמסירת פרטיי האישיים
              נעשית מרצוני החופשי, ואני מסכים/ה לעיבודם ולשמירתם,
              בהתאם ל־{' '}
              <Anchor href="https://www.creditpro.co.il/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%94%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA" underline="always" target="_blank" className={classes.link}>
                מדיניות הפרטיות
              </Anchor>{' '}
              ול־{' '}
              <Anchor href="https://www.creditpro.co.il/%D7%AA%D7%A0%D7%90%D7%99-%D7%A9%D7%99%D7%9E%D7%95%D7%A9-%D7%91%D7%90%D7%AA%D7%A8" underline="always" target="_blank" className={classes.link}>
                תנאי השימוש
              </Anchor>{' '}
              של המערכת.
            </Text>
          </Stack>

          <Button
            size="lg"
            radius="xl"
            className={classes.cta}
            onClick={handleContinue}
            disabled={loading}
          >
            {loading ? <Loader size="sm" /> : 'הסכמה והמשך התהליך'}
          </Button>
        </div>
      </Center>
    </Box>
  );
};

export default TermsOfUse;
